<template>
  <div class="hover-popup-coupling" :class="{right: couplingLabel === 'B'}">
    <div class="left">
      <span class="title">{{ $t('hose.contrary') }}</span>
      <img :src="getFromStorage(coupling.render_opposite)" alt="">
    </div>
    <div class="right">
      <span class="title">{{ $t('hose.coupling') }} {{ couplingLabel }}</span>
      <img :src="getFromStorage(coupling.render_measurements)" alt="">
    </div>
  </div>
</template>

<script>
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "HoverPopupCoupling",
  methods: {getFromStorage},
  props: ['coupling', 'couplingLabel'],
}
</script>

<style scoped lang="scss">
.hover-popup-coupling {
  pointer-events: none;
  position: absolute;
  min-width: 256px;
  max-width: 512px;
  height: auto;
  display: flex;
  background: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-family: "Neue Haas Grotesk Display Pro", sans-serif;
  font-size: 12px;
  font-weight: bolder;
  color: #3C3C3B;
  z-index: 3;
  left: 16px;
  top: 250px;

  &.right {
    left: unset;
    right: 16px;
  }

  .left, .right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 8px;

    img {
      max-width: 100%;
    }
  }

  .left {
    background: #EBEBEB;

    img {
      min-width: 100%;
      height: auto;
      margin: auto 0 auto -8px;
    }
  }

  .right {
    flex-grow: 1;

    img {
      margin: auto;
    }
  }
}
</style>
